import React from 'react';
import './styles.css';
import DonutChart from './DonutChart';


const JobTrendCard = () => {

  return (
    <div class="donut-chart" style={{ marginRight: '30px' }}>
      <div style={{ fontSize: '12px', fontWeight: 600, marginTop: '10px' }}>Total Job trend-Executed Vs Submitted</div>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '25px'}}>
        <DonutChart isStatusChart={false}/>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '125px', marginLeft: '-16px' }}>
          <span className="dot"></span>
          <div>Executed -</div>
          <div style={{ marginLeft: '-2px' }}>18</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '132px', marginLeft: '25px' }}>
          <span className="dot" style={{ background: '#FE9400' }}></span>
          <div>Submitted -</div>
          <div>22</div>
        </div>
      </div>


    </div>

  )

}

export default JobTrendCard;